import { AuthPages } from 'src/pages/auth'

const AuthRoutes = [
  {
    path: '/administrator/sign-in',
    component: <AuthPages.SignIn />,
    exact: true,
    meta: {
      authRoute: true
    }
  },
]

export default AuthRoutes
